import { filterValuesSeparatorSplitRegex } from 'shared-helpers/consts';

import type { FilterState } from '.';

/**
 * Parse query-like string params into FilterState for known filter field keys.
 */
export const buildFilterStateFromParamRecord = (
  source: Record<string, string | string[] | undefined>,
  fieldKeyPredicate: (key: string) => boolean
): FilterState => {
  const initialState: FilterState = {};

  Object.keys(source).forEach((key) => {
    if (!fieldKeyPredicate(key)) return;
    const raw = source[key];
    const str = Array.isArray(raw) ? raw[0] : raw;
    if (str === undefined || str === '') return;
    initialState[key] = String(str)
      .split(filterValuesSeparatorSplitRegex)
      .reduce(
        (filters, item) => {
          filters[item] = true;
          return filters;
        },
        {} as { [value: string]: true }
      );
  });

  return initialState;
};
